import React, { useEffect } from "react";
import PropTypes from "prop-types";
import SectionToggle from "../../../../components/sectionToggle/sectionToggle";
import { actionCreators } from "./redux/introBreakdownSagas";
import { useDispatch, useSelector } from "react-redux";
import PricingOptions from "./smartComponents/pricingOptions";
import CustomDateRanges from "./smartComponents/customDateRanges";
import DatePicker from "./smartComponents/datePicker";
import NumberDisplay from "../../../../components/moneyDisplay/moneyDisplay";
import LoadingAnimation from "../../../../components/loadingAnimation/loadingAnimation";
import SectionContainer from "../../../../components/sectionContainer/sectionContainer";
import PieChart from "../../../../components/pieChart/pieChart";
import IntroBreakdownTable from "./smartComponents/introBreakdownTable";
import LearnMore from "../../../../components/learnMore/learnMore";
const IntroBreakdownModule = (props) => {
  const {
    isUpdating,
    initialRequest,
    filtersDirty,
    isLoading,
    selectedRequestDates: { startDate, endDate },
    dataPoints,
    introsSoldPieChart,
    visitsPieChart,
    tableData
  } = useSelector((state) => state.introBreakdown);
  const isUserQa = useSelector((state) => state.commonReducer.commonProps.qa);

  const dispatch = useDispatch();

  const updateData = () => {
    if (filtersDirty) {
      dispatch(actionCreators.updateData());
    }
  };
  const resetData = () => {
    dispatch(actionCreators.resetData());
  };

  useEffect(() => {
    !initialRequest && dispatch(actionCreators.fetchCurrentUser(props));
  }, []);

  const content = () => {
    return (
      <div id="intro-breakdown">
        <div className="edit-selections-bar">
          <div className="select-box">
            <p className="offers-title">Sales Packages</p>
            <PricingOptions />
          </div>

          <div className="select-box">
            <p className="offers-title">Date Range</p>
            <CustomDateRanges />
          </div>

          <div className="date-select-box multi">
            <p className="offers-title">Date</p>
            <DatePicker />
          </div>

          {filtersDirty &&
            !isLoading &&
            startDate !== "Invalid Date" &&
            endDate !== "Invalid Date" ? (
            <button className="submit" onClick={() => updateData()}>
              Update
            </button>
          ) : null}

          {filtersDirty && !isLoading ? (
            <button className="submit reset" onClick={() => resetData()}>
              Reset
            </button>
          ) : null}
        </div>

        {!isUpdating ? (
          <>
            <div className="data-points">
              {dataPoints &&
                dataPoints.map((dataPoint, ind) => {
                  return (
                    <div key={ind} className="data-points__elem">
                      <SectionContainer title={dataPoint.label}>
                        <NumberDisplay
                          value={dataPoint.value}
                          url={dataPoint.link ? dataPoint.link : ""}
                          disableAnimation={isUserQa}
                        />
                      </SectionContainer>
                    </div>
                  );
                })}
            </div>
            {introsSoldPieChart.length !== 0 && visitsPieChart.length !== 0 ? (
              <div className="pie-chart">
                <div className="pie-chart__el">
                  <PieChart
                    data={introsSoldPieChart}
                    width={675}
                    height={300}
                    responsive={false}
                    maxSlices={6}
                    showLegend
                    legendPosition="right"
                    isLegendTooltip
                    showPercent
                  />
                </div>
                <div className="pie-chart__el">
                  <PieChart
                    data={visitsPieChart}
                    width={675}
                    height={300}
                    maxSlices={6}
                    addOtherLabel={false}
                    isSortable={false}
                    customTooltip
                    showLegend
                    legendPosition="right"
                    showPercent
                  />
                </div>
              </div>
            ) : (
              ""
            )}
            <IntroBreakdownTable table={tableData} />
          </>
        ) : (
          <LoadingAnimation text="Updating data..." />
        )}
      </div>
    );
  };
  return (
    <SectionToggle
      isLoading={isLoading}
      title={props.chartName}
      content={content()}
      learnMore={<LearnMore title={props.chartName} content={learnMoreContent} />}
    />
  );
};

const learnMoreContent = (
  <>
    The goal of this module is to track which visit your intro buyers convert on. Suggestions, or
    ways to relate to the data you see, for this module to verify your sales process by how long
    your intro buyers take to convert over. With option to compare by other current or former intro
    offers types.
    <br />
    <br />
    <b>Date Selection Tip:</b> Remember that offers sold recently might not have time to convert
    yet. If recently sold offers are being compared to older offers, it is a good idea to set the
    date back to a time that gives all purchasers time to make that second purchase (3 weeks-2
    months).
    <br />
    <br />
    <h3>Intros Sold</h3>
    Total number of intros sold based by sales package and calendar filters.
    <br />
    <br />
    <h3>Avg. visits to conversion</h3>
    Average number of visits from intro purchase to first qualifying purchase; class card and/or
    membership.
    <br />
    <br />
    <h3>Avg. visits to membership conversion</h3>
    Average number of visits from intro purchase to membership purchase. <br />
    <br />
    <h3>Avg. days to conversion</h3>
    Average number of days from intro purchase to first qualifying purchase; class card and/or
    membership.
    <br />
    <br />
    <h3>Avg. days to membership conversion</h3>
    Average number of days from intro purchase to membership purchase.
    <br />
    <br />
    <h3>Pie charts</h3>
    (Left-side) Percentage of intro buyers based by intro offer type. (Right-side) Percentage of
    intro conversion based by their converting visit.
    <br />
    <br />
    <h3>Filter</h3>
    Only updates the table and allows you to filter to specific intro offer types.
    <br />
    <br />
    <h3>Table</h3>
    Breaks down each intro offer type, displays number of intro sold, and percentage of conversions
    by converting date.
  </>
);

IntroBreakdownModule.propTypes = { params: PropTypes.object };

export default React.memo(IntroBreakdownModule);
